var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"row\">\n<h4>Filter by Event Category</h4>\n<ul>\n<li ng-click=\"$categoryFilterListCtrl.clearFilter()\" ng-class=\"{ 'wb-filter-active': !$categoryFilterListCtrl.filters.event_group }\">All Categories</li>\n<li ng-repeat=\"event_group in $categoryFilterListCtrl.eventGroups\" ng-click=\"$categoryFilterListCtrl.filterClicked(event_group)\" ng-class=\"{ 'wb-filter-active': $categoryFilterListCtrl.filters.event_group == event_group }\"><span ng-if=\"$categoryFilterListCtrl.showCompanyNames\">{{event_group.companyName}} - </span>{{event_group.name}}</li>\n</ul>\n</div>";
var id1="javascripts/category-filter-list/category_filter_list.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/javascripts/category-filter-list/category_filter_list.template.html
// module id = 1299
// module chunks = 0